// extracted by mini-css-extract-plugin
export default {"selection":"GroupSelect_selection__hbPg5","formItem":"GroupSelect_formItem__yjW4l","extraInfo":"GroupSelect_extraInfo__6yD-n"};